export class GeoTileBounds {srid: any;YMin: any;YMax: any;XMin: any;XMax: any;
  
  constructor(xMax:any,xMin:any,yMax:any,yMin:any,srid:any){
    this.XMax = xMax;
    this.XMin = xMin;
    this.YMax = yMax;
    this.YMin = yMin;
    this.srid = srid;
  }
}